import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { Injectable } from '@angular/core';
import { FinishProService } from "../finish-pro/services/finish-pro.service";
import { PersonalizationsService } from "../base/services/personalizations/personalizations.service";
import { Environment } from "../models/environment";

@Injectable({
  providedIn: "root"
})
export class FinishOperationGuardService implements CanActivate {

  signerGuid: string = null;

  environment: Environment;

  constructor(
    private _router: Router,
    private _finishProService: FinishProService,
    private _personalization: PersonalizationsService
  ) {
    this.environment = this._personalization.sendEnv;
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const operationId: string = this.getOperationIdByUrl(state);
    this._finishProService.setOperationID(operationId);
    const hasPermission = await this._finishProService.hasPermissionToFinishPro();
    if (this._finishProService.isFinishPro && !this.environment.features.webcomponentFinish) {
      this._router.navigate(['/finishProOperation', operationId]);
      return false;
    }


    return true;
  }

  getOperationIdByUrl(state: RouterStateSnapshot): string {
    let operationId = '';
    this.signerGuid = new URLSearchParams(window.location.search).get('signerGuid');

    if (state.url.includes('code') && state.url.includes('state')) {
      operationId = state.url.split('/').slice(-1)[0];

      if (operationId.includes('%')) {
        operationId = operationId.split('%')[0];
      }

      // Redirección desde Universign
      if (operationId.includes('?code')) {
        operationId = operationId.split('?code')[0];
      }
    } else {
      operationId = state.url.split('/').slice(-1)[0];
    }

    // Tiene signerGuid (operación con firmante alternativo)
    if (operationId.includes('signerGuid')) {
      const operationidDecoded = decodeURIComponent(operationId);
      const params = operationidDecoded.split('?signerGuid=');

      operationId = params[0];
      this.signerGuid = params[1];
    }

    return operationId;
  }

}
